'use client';

import type { ReactNode } from 'react';

import { Provider as JotaiProvider } from 'jotai';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { I18nProvider as AriaI18nProvider } from 'react-aria';

import ActiveSectionContextProvider from '@/store/context/active-section';
import { TRPCReactProvider } from '@/trpc/client';

import { AppToastProvider } from './toast/provider.client';

export function AppProviders({
  children,
  locale,
}: Readonly<{
  children: ReactNode;
  locale?: string;
}>) {
  return (
    // <NextIntlClientProvider
    //   locale={locale ?? 'en'}
    //   onError={(error) => console.error(error)}
    //   getMessageFallback={({ namespace, key }) => `${namespace}.${key}`}
    // >
    <TRPCReactProvider>
      <NuqsAdapter>
        <AriaI18nProvider locale={locale}>
          <AppToastProvider>
            <ActiveSectionContextProvider>
              <JotaiProvider>{children}</JotaiProvider>
            </ActiveSectionContextProvider>
          </AppToastProvider>
        </AriaI18nProvider>
      </NuqsAdapter>
    </TRPCReactProvider>
    // </NextIntlClientProvider>
  );
}
